export const errorLogger = (error, prefix = '') => {
  // eslint-disable-next-line no-console
  console.log(prefix, error);
};
